import { axiosInstance } from '@/utils/lib/axios';
import { Spinner } from 'alurkerja-ui';
import { useKeycloak } from 'keycloak-react-web';
import React, { useEffect } from 'react';

type ProtectedRouteProps = {
  layout: React.FC;
};

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ layout: Layout }) => {
  const { keycloak, initialized } = useKeycloak();

  useEffect(() => {
    if (initialized) {
      if (keycloak.authenticated) {
        axiosInstance.interceptors.request.use(config => {
          return keycloak
            .updateToken(5)
            .then(() => {
              config.headers.Authorization = `Bearer ${keycloak.token}`;
              return config;
            })
            .catch(() => {
              keycloak.login();
              return Promise.reject(new Error('Unauthorized'));
            });
        });
      } else {
        keycloak.login({
          redirectUri: window.location.origin + '/',
        });
      }
    }
  }, [initialized, keycloak]);

  if (keycloak.authenticated) {
    return <Layout />;
  }

  return (
    <div className="fixed flex items-center justify-center w-screen h-screen gap-2">
      <Spinner className="text-main-blue-alurkerja" />
      Loading...
    </div>
  );
};
